import React, { Fragment, useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import TodoList from '../components/todos/TodoList'
import ProjectTitle from '../components/project/ProjectTitle'
import { sortByStartDate } from '../data/sorting'
import PageTemplate from './templates/PageTemplate'
import { FOCUS, VIEW_ALL_FOCUS } from '../data/focus'
import LOG from '../logging/Logger'

const AllGrid = ({
  scrollRef,
  textFilter,
  tagsFilter,
  showAll,
  project,
  projectId,
  setEditMode,
  getTodos,
  decrypt,
  editTodoStatus,
  getRepeatPattern,
  getProjectNameForTodo,
  redirectToProject,
  getProjectsForAreas,
  clientId,
  createProject,
  deleteTodo,
  getProjectById,
  editTodo,
  getAvailableTags,
  createTodo,
  getAreas,
  getTagsFromTodo,
  createAttachment,
  deleteAttachment,
  editAttachment,
  downloadAttachment,
  getTodoAttachments,
  cacheDragList,
  setInfo,
  setWarning,
  setError,
  getAreaById
}) => {
  LOG.debug('Render: AllPage: AllGrid')

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {(!projectId || project) && (
          <Fragment>
            {VIEW_ALL_FOCUS.map(focus => (
              <Fragment key={focus.id}>
                {focus.id !== FOCUS.SCHEDULED.id &&
                  focus.id !== FOCUS.REPEATING.id && (
                    <Fragment>
                      <TodoList
                        title={focus.title}
                        scrollRef={scrollRef}
                        showZen={false}
                        showAll={showAll}
                        textFilter={textFilter}
                        tagsFilter={tagsFilter}
                        projectFilter={projectId}
                        list={focus.id}
                        getTodos={getTodos}
                        decrypt={decrypt}
                        editTodoStatus={editTodoStatus}
                        getRepeatPattern={getRepeatPattern}
                        getProjectNameForTodo={getProjectNameForTodo}
                        redirectToProject={redirectToProject}
                        getProjectsForAreas={getProjectsForAreas}
                        clientId={clientId}
                        createProject={createProject}
                        deleteTodo={deleteTodo}
                        getProjectById={getProjectById}
                        editTodo={editTodo}
                        getAvailableTags={getAvailableTags}
                        createTodo={createTodo}
                        getAreas={getAreas}
                        getTagsFromTodo={getTagsFromTodo}
                        createAttachment={createAttachment}
                        deleteAttachment={deleteAttachment}
                        editAttachment={editAttachment}
                        downloadAttachment={downloadAttachment}
                        getTodoAttachments={getTodoAttachments}
                        cacheDragList={cacheDragList}
                        setInfo={setInfo}
                        setWarning={setWarning}
                        setError={setError}
                        getAreaById={getAreaById}
                      />
                    </Fragment>
                  )}
                {focus.id === FOCUS.SCHEDULED.id && (
                  <Fragment>
                    <TodoList
                      title={focus.title}
                      hideIfEmpty={true}
                      scrollRef={scrollRef}
                      showAdd={false}
                      hasStatus={true}
                      showZen={false}
                      textFilter={textFilter}
                      tagsFilter={tagsFilter}
                      projectFilter={projectId}
                      list={FOCUS.TODAY.id}
                      droppableId={FOCUS.SCHEDULED.id}
                      current={false}
                      future={true}
                      draggable={false}
                      sortBy={sortByStartDate}
                      getTodos={getTodos}
                      decrypt={decrypt}
                      editTodoStatus={editTodoStatus}
                      getRepeatPattern={getRepeatPattern}
                      getProjectNameForTodo={getProjectNameForTodo}
                      redirectToProject={redirectToProject}
                      getProjectsForAreas={getProjectsForAreas}
                      clientId={clientId}
                      createProject={createProject}
                      deleteTodo={deleteTodo}
                      getProjectById={getProjectById}
                      editTodo={editTodo}
                      getAvailableTags={getAvailableTags}
                      createTodo={createTodo}
                      getAreas={getAreas}
                      getTagsFromTodo={getTagsFromTodo}
                      createAttachment={createAttachment}
                      deleteAttachment={deleteAttachment}
                      editAttachment={editAttachment}
                      downloadAttachment={downloadAttachment}
                      getTodoAttachments={getTodoAttachments}
                      cacheDragList={() => {}}
                      setInfo={setInfo}
                      setWarning={setWarning}
                      setError={setError}
                      getAreaById={getAreaById}
                    />
                  </Fragment>
                )}
                {focus.id === FOCUS.REPEATING.id && (
                  <Fragment>
                    <TodoList
                      title={focus.title}
                      hideIfEmpty={true}
                      scrollRef={scrollRef}
                      hasStatus={false}
                      showAdd={false}
                      showZen={false}
                      textFilter={textFilter}
                      tagsFilter={tagsFilter}
                      projectFilter={projectId}
                      list={FOCUS.REPEATING.id}
                      current={true}
                      future={true}
                      draggable={false}
                      sortBy={sortByStartDate}
                      getTodos={getTodos}
                      decrypt={decrypt}
                      editTodoStatus={editTodoStatus}
                      getRepeatPattern={getRepeatPattern}
                      getProjectNameForTodo={getProjectNameForTodo}
                      redirectToProject={redirectToProject}
                      getProjectsForAreas={getProjectsForAreas}
                      clientId={clientId}
                      createProject={createProject}
                      deleteTodo={deleteTodo}
                      getProjectById={getProjectById}
                      editTodo={editTodo}
                      getAvailableTags={getAvailableTags}
                      createTodo={createTodo}
                      getAreas={getAreas}
                      getTagsFromTodo={getTagsFromTodo}
                      createAttachment={createAttachment}
                      deleteAttachment={deleteAttachment}
                      editAttachment={editAttachment}
                      downloadAttachment={downloadAttachment}
                      getTodoAttachments={getTodoAttachments}
                      cacheDragList={() => {}}
                      setInfo={setInfo}
                      setWarning={setWarning}
                      setError={setError}
                      getAreaById={getAreaById}
                    />
                  </Fragment>
                )}
              </Fragment>
            ))}
          </Fragment>
        )}
      </Grid>
    </Grid>
  )
}

export default ({
  scrollRef = null,
  match: {
    params: { id: projectId }
  },
  getAvailableTags,
  getProjectById,
  editProject,
  decrypt,
  deleteProject,
  getTodos,
  editTodoStatus,
  getRepeatPattern,
  getProjectNameForTodo,
  redirectToProject,
  getProjectsForAreas,
  clientId,
  createProject,
  deleteTodo,
  editTodo,
  createTodo,
  getAreas,
  moveTodoToTrash,
  getTagsFromTodo,
  createAttachment,
  deleteAttachment,
  editAttachment,
  downloadAttachment,
  getTodoAttachments,
  cacheDragList,
  setInfo,
  setWarning,
  setError,
  getAreaById
}) => {
  LOG.debug('Render: AllPage')

  const [editMode, setEditMode] = useState(false)

  const [project, setProject] = useState(null)

  useEffect(() => {
    if (projectId) {
      const foundProject = getProjectById(projectId)
      if (foundProject) {
        setProject(foundProject)
      }
    }
  }, [projectId, getProjectById])

  const handleUpdateProject = async (
    name,
    description,
    area,
    autoPromote,
    autoDelete
  ) => {
    if (project) {
      await editProject(
        project.id,
        name,
        description,
        area,
        autoPromote,
        autoDelete
      )
    }
  }

  const title = project && (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={12}>
          <ProjectTitle
            project={project}
            onUpdateProject={handleUpdateProject}
            onDeleteProject={e => deleteProject(project)}
            onEditMode={isEditing => setEditMode(isEditing)}
            getAreas={getAreas}
            decrypt={decrypt}
          />
        </Grid>
      </Grid>
    </Grid>
  )

  return (
    <PageTemplate
      title={title}
      showSpeedDial={!editMode}
      showSearchOverride={editMode ? false : undefined}
      deleteTodo={deleteTodo}
      getTodos={getTodos}
      moveTodoToTrash={moveTodoToTrash}
      getAvailableTags={getAvailableTags}
    >
      <AllGrid
        projectId={projectId}
        project={project}
        setEditMode={setEditMode}
        getTodos={getTodos}
        decrypt={decrypt}
        editTodoStatus={editTodoStatus}
        getRepeatPattern={getRepeatPattern}
        getProjectNameForTodo={getProjectNameForTodo}
        redirectToProject={redirectToProject}
        getProjectsForAreas={getProjectsForAreas}
        clientId={clientId}
        createProject={createProject}
        deleteTodo={deleteTodo}
        getProjectById={getProjectById}
        editTodo={editTodo}
        getAvailableTags={getAvailableTags}
        createTodo={createTodo}
        editProject={editProject}
        deleteProject={deleteProject}
        getAreas={getAreas}
        cacheDragList={cacheDragList}
        getTagsFromTodo={getTagsFromTodo}
        createAttachment={createAttachment}
        deleteAttachment={deleteAttachment}
        editAttachment={editAttachment}
        downloadAttachment={downloadAttachment}
        getTodoAttachments={getTodoAttachments}
        scrollRef={scrollRef}
        setInfo={setInfo}
        setWarning={setWarning}
        setError={setError}
        getAreaById={getAreaById}
      />
    </PageTemplate>
  )
}
